/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    ariaLabel: "Click to change the picture",
    cancelBtn: "Cancel",
    pickerTitle: {
        innerHTML: "Upload Image"
    },
    sizeRecommandation: {
        innerHTML: "Prefer a picture of 800*400px"
    }
};